module.exports = "pegasus_template/assets/email1-facebook-icon.png";